import { DialogTitle,DialogActions,DialogContent,Button  } from '@mui/material';

import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import "./AddEmailDialog.scss";
import {
  sendVerificationEmail,
  validateEmail,
} from "../../utils/services/emailService";

interface FormData {
  emailAddress: string;
}

function AddEmailDialog() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch
  } = useForm<FormData>();
  const form = useRef<HTMLFormElement>(null);
  const [timerCountdown, setTimerCountdown] = useState<number>(60);
  const [sendEmail, setSendEmail] = useState<string | undefined>(undefined);
  const [currentPage, setCurrentPage] = useState<string>("getEmail");

  const onSubmit = async (data: FormData) => {
    const response = await sendVerificationEmail(data?.emailAddress);
    if (response?.status === 200) {
      setCurrentPage("confirmEmail");
      runTimer();
      setSendEmail(data?.emailAddress);
    }
  };

  const runTimer = () => {
    setTimeout(() => {
      setTimerCountdown((s) => (s > 1 ? s - 1 : 0));
      if (timerCountdown > 0) {
        runTimer();
      }
    }, 1000);
  };

  const resendEmail = () => {
    if (timerCountdown === 0) {
      sendVerificationEmail(sendEmail || "");
      setTimerCountdown(60);
      runTimer();
    }
  };

  return (
    <div className="emailDialog">
      <DialogTitle>{"Verify E-Mail"}</DialogTitle>
      {currentPage === "getEmail" ? (
        <DialogContent>
          <form
            ref={form}
            className="emailForm"
            onSubmit={handleSubmit(onSubmit)}
          >
            <p>
              Your Lighthouse account needs to be associated with an email.
              Connect your email address to access all your lighthouse features.
            </p>
            <div className="fieldContainer">
              <input
                type="text"
                placeholder="Email Address"
                className={errors.emailAddress ? "errorInput" : ""}
                {...register("emailAddress", {
                  required: true,
                  validate: validateEmail,
                })}
              />
              {errors.emailAddress &&
                errors.emailAddress.type === "required" && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
              {errors.emailAddress &&
                errors.emailAddress.type === "validate" && (
                  <span className="fieldContainer__error">
                    Enter Valid Email
                  </span>
                )}
            </div>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0rem",
              }}
            >
              <Button
                type="submit"
                disabled={!!errors.emailAddress}
              >{`Verify`}</Button>
            </DialogActions>
          </form>
        </DialogContent>
      ) : (
        <DialogContent>
          <p>
            The Email was successfully sent to <b>{watch()?.emailAddress}</b>.
            Please click on the link attached in the email to verify your email.
          </p>
          <p>
            wrong email?{" "}
            <span
              style={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => {
                setCurrentPage("getEmail");
              }}
            >
              Change Here
            </span>
          </p>
          <p>
            Haven&#39;t received the email?{" "}
            <span
              style={
                timerCountdown > 0
                  ? { color: "#6e6666", cursor: "auto" }
                  : { textDecoration: "underline", cursor: "pointer" }
              }
              onClick={resendEmail}
            >
              Send Again {timerCountdown > 0 && <>({timerCountdown}s)</>}
            </span>
          </p>
        </DialogContent>
      )}
    </div>
  );
}

export default AddEmailDialog;